<template>
  <div class="teacher-management-container">
    <Assistant_teacher_bar />

    <v-container fluid class="pa-6">
      <!-- Header Section -->
      <div class="header-section mb-8">
        <v-row align="center">
          <v-col cols="12" md="8">
            <div class="page-title-container">
              <v-icon color="primary" size="36" class="mr-3">mdi-school</v-icon>
              <div>
                <h1 class="page-title mb-1">การแต่งตั้งคณะกรรมการประเมิน</h1>
                <p class="page-subtitle">ตำแหน่งครูผู้ช่วย - รอบบรรจุ</p>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="text-right">
            <v-btn
              @click="updateCommitteeList"
              :loading="loadingCommittee"
              color="primary"
              elevation="2"
              rounded
              class="mr-2"
            >
              <v-icon left>mdi-account-group</v-icon>
              อัปเดตกรรมการ
            </v-btn>
            <v-btn
              @click="updateEvaluationScores"
              :loading="loadingScores"
              color="success"
              elevation="2"
              rounded
            >
              <v-icon left>mdi-chart-line</v-icon>
              ปรับปรุงคะแนน
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <!-- Statistics Dashboard -->
      <v-row class="mb-6">
        <!-- Chart Card -->
        <v-col cols="12" md="8">
          <v-card class="stats-card elevation-4" rounded="xl">
            <v-card-title class="stats-card-title">
              <v-icon color="primary" class="mr-2">mdi-chart-donut</v-icon>
              ภาพรวมสถิติการบรรจุ
            </v-card-title>
            <v-card-text>
              <div id="statistics-chart" style="height: 300px;"></div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Stats Cards -->
        <v-col cols="12" md="4">
          <v-card class="stats-mini-card total-card" rounded="lg" elevation="3">
            <v-card-text class="text-center">
              <v-icon size="40" color="white" class="mb-2"
                >mdi-account-check</v-icon
              >
              <h3 class="white--text mb-1">
                {{ statistics.totalReported }}
              </h3>
              <p class="white--text mb-0">เรียกรายงานตัว</p>
            </v-card-text>
          </v-card>
          <v-card
            class="stats-mini-card active-card"
            rounded="lg"
            elevation="3"
          >
            <v-card-text class="text-center">
              <v-icon size="40" color="white" class="mb-2"
                >mdi-account-group</v-icon
              >
              <h3 class="white--text mb-1">
                {{ statistics.currentActive }}
              </h3>
              <p class="white--text mb-0">ปัจจุบัน</p>
            </v-card-text>
          </v-card>
          <v-card class="stats-mini-card left-card" rounded="lg" elevation="3">
            <v-card-text class="text-center">
              <v-icon size="40" color="white" class="mb-2"
                >mdi-account-minus</v-icon
              >
              <h3 class="white--text mb-1">{{ statistics.totalLeft }}</h3>
              <p class="white--text mb-0">ออกจากระบบ</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Data Table Card -->
      <v-card class="data-table-card elevation-4" rounded="xl">
        <v-card-title class="data-table-title">
          <v-icon color="primary" class="mr-3">mdi-table</v-icon>
          <span>ข้อมูลการบรรจุครูผู้ช่วย</span>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchText"
            append-icon="mdi-magnify"
            label="ค้นหาข้อมูล..."
            single-line
            hide-details
            outlined
            dense
            class="search-field"
            style="max-width: 300px;"
          />
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0">
          <v-row class="mb-4">
            <v-col cols="12" md="3">
              <v-text-field
                v-model="searchText"
                append-icon="mdi-magnify"
                label="ค้นหาทั่วไป"
                dense
                outlined
                clearable
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-menu
                ref="menuDateApps"
                v-model="menuDateApps"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filterDateApps"
                    label="วันที่บรรจุ"
                    prepend-icon="mdi-calendar"
                    readonly
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    clearable
                  />
                </template>
                <v-date-picker
                  v-model="filterDateApps"
                  @input="menuDateApps = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3">
              <v-menu
                ref="menuDateWork"
                v-model="menuDateWork"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="filterDateWork"
                    label="วันที่ปฏิบัติงาน"
                    prepend-icon="mdi-calendar"
                    readonly
                    dense
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    clearable
                  />
                </template>
                <v-date-picker
                  v-model="filterDateWork"
                  @input="menuDateWork = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                v-model="filterPersonnelType"
                :items="personnelTypes"
                item-text="text"
                item-value="value"
                label="ประเภท"
                dense
                outlined
                clearable
              />
            </v-col>
          </v-row>

          <v-data-table
            :headers="tableHeaders"
            :items="filteredTeacherData"
            :loading="loadingTable"
            :search="searchText"
            class="modern-table"
            :items-per-page="15"
            :footer-props="{
              'items-per-page-options': [10, 15, 25, 50],
              'items-per-page-text': 'รายการต่อหน้า:',
              'page-text': '{0}-{1} จาก {2}'
            }"
          >
            <!-- Loading -->
            <template v-slot:loading>
              <div class="text-center pa-4">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <p class="mt-2">กำลังโหลดข้อมูล...</p>
              </div>
            </template>

            <!-- Action Buttons -->
            <template v-slot:item.personalCheck="{ item }">
              <v-btn
                color="deep-purple"
                small
                fab
                :to="getPersonalCheckRoute(item)"
                title="ตรวจสอบบุคคล"
                class="action-btn"
              >
                <v-icon small>mdi-account-circle</v-icon>
              </v-btn>
            </template>

            <template v-slot:item.committeeProposal="{ item }">
              <v-btn
                color="amber darken-3"
                small
                fab
                :to="getCommitteeRoute(item)"
                title="เสนอกรรมการ"
                class="action-btn"
              >
                <v-icon small>mdi-numeric-2-box</v-icon>
              </v-btn>
            </template>

            <template v-slot:item.evaluation="{ item }">
              <v-btn
                color="pink"
                small
                fab
                :to="getEvaluationRoute(item)"
                title="การประเมิน"
                class="action-btn"
              >
                <v-icon small>mdi-numeric-3-box</v-icon>
              </v-btn>
            </template>

            <template v-slot:item.reports="{ item }">
              <v-btn
                color="green darken-3"
                small
                fab
                :to="getReportsRoute(item)"
                title="รายงาน"
                class="action-btn"
              >
                <v-icon small>mdi-file-chart</v-icon>
              </v-btn>
            </template>

            <!-- Transfer Buttons -->
            <template v-slot:item.transferCommittee="{ item }">
              <v-btn
                v-if="item.counttransfer_position > 0"
                color="brown darken-1"
                small
                fab
                :to="getTransferCommitteeRoute(item)"
                title="เสนอกรรมการ (โอน)"
                class="action-btn"
              >
                <v-icon small>mdi-numeric-2-box</v-icon>
              </v-btn>
              <span v-else class="text-center">-</span>
            </template>

            <template v-slot:item.transferEvaluation="{ item }">
              <v-btn
                v-if="item.counttransfer_position > 0"
                color="pink darken-3"
                small
                fab
                :to="getTransferEvaluationRoute(item)"
                title="การประเมิน (โอน)"
                class="action-btn"
              >
                <v-icon small>mdi-numeric-3-box</v-icon>
              </v-btn>
              <span v-else class="text-center">-</span>
            </template>

            <template v-slot:item.transferReports="{ item }">
              <v-btn
                v-if="item.counttransfer_position > 0"
                color="teal darken-2"
                small
                fab
                :to="getTransferReportsRoute(item)"
                title="รายงาน (โอน)"
                class="action-btn"
              >
                <v-icon small>mdi-file-chart</v-icon>
              </v-btn>
              <span v-else class="text-center">-</span>
            </template>

            <!-- Personnel Type -->
            <template v-slot:item.personnelType="{ item }">
              <v-chip
                :color="getPersonnelTypeColor(item.mt_type_personnel)"
                dark
                small
                rounded
                class="personnel-chip"
              >
                <v-icon
                  small
                  left
                  color="red"
                  v-if="
                    getPersonnelTypeText(item.mt_type_personnel) === 'ไม่ระบุ'
                  "
                >
                  mdi-alert
                </v-icon>
                {{ getPersonnelTypeText(item.mt_type_personnel) }}
              </v-chip>
            </template>

            <!-- Documents -->
            <template v-slot:item.documents="{ item }">
              <v-btn
                color="indigo"
                small
                fab
                :to="getDocumentsRoute(item)"
                title="จัดการเอกสาร"
                class="action-btn"
              >
                <v-icon small>mdi-file-document-edit</v-icon>
              </v-btn>
            </template>

            <!-- Dates -->
            <template v-slot:item.dateApps="{ item }">
              <div class="date-cell">
                {{ formatAppointmentDate(item) }}
              </div>
            </template>

            <template v-slot:item.mt_date_app_now="{ item }">
              <div class="date-cell">
                {{ formatAppointmentDate(item) }}
              </div>
            </template>

            <!-- Settings -->
            <template v-slot:item.settings="{ item }">
              <v-btn
                fab
                small
                color="orange"
                @click="openSettingsDialog(item)"
                title="ตั้งค่าข้อมูล"
                class="action-btn"
              >
                <v-icon small>mdi-cog</v-icon>
              </v-btn>
            </template>

            <!-- Order File -->
            <template v-slot:item.orderFile="{ item }">
              <v-btn
                v-if="item.pertem_assistantFileIpastatus === 'notice'"
                @click="viewOrderFile(item.pertem_assistantFileIpa)"
                icon
                color="red"
                title="ดูไฟล์คำสั่ง"
                class="action-btn"
              >
                <v-icon>mdi-file-pdf-box</v-icon>
              </v-btn>
              <span v-else class="text-center">-</span>
            </template>

            <!-- Month Templates -->
            <template v-slot:item.month6="{ item }">
              <div class="date-cell">{{ formatDate(item.month6) }}</div>
            </template>
            <template v-slot:item.month12="{ item }">
              <div class="date-cell">{{ formatDate(item.month12) }}</div>
            </template>
            <template v-slot:item.month18="{ item }">
              <div class="date-cell">{{ formatDate(item.month18) }}</div>
            </template>
            <template v-slot:item.month24="{ item }">
              <div class="date-cell">{{ formatDate(item.month24) }}</div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <!-- Settings Dialog -->
      <v-dialog v-model="settingsDialog.show" persistent max-width="700px">
        <v-card class="settings-dialog-card" rounded="xl" elevation="8">
          <v-card-title class="settings-dialog-title">
            <v-icon color="primary" class="mr-3">mdi-cog</v-icon>
            <span>ปรับปรุงข้อมูลการบรรจุ</span>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text class="pa-6">
            <v-form ref="settingsForm" lazy-validation>
              <div class="appointment-date-display">
                <v-icon color="primary" class="mr-2">mdi-calendar</v-icon>
                <span
                  >วันที่บรรจุ:
                  {{ formatAppointmentDate(settingsDialog.data) }}</span
                >
              </div>

              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    :items="personnelTypes"
                    item-text="text"
                    item-value="value"
                    label="รอบการบรรจุ"
                    v-model="settingsDialog.data.mt_type_personnel"
                    :rules="requiredRules"
                    outlined
                    prepend-icon="mdi-clock"
                    class="modern-input"
                  />
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    label="จำนวนบรรจุ"
                    v-model="settingsDialog.data.mt_numfirst"
                    type="number"
                    :rules="requiredRules"
                    outlined
                    prepend-icon="mdi-account-group"
                    class="modern-input"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="เลขที่คำสั่ง"
                    v-model="settingsDialog.data.mt_order_app"
                    :rules="requiredRules"
                    outlined
                    prepend-icon="mdi-file-document"
                    class="modern-input"
                  />
                </v-col>

                <v-col cols="12">
                  <v-file-input
                    v-model="selectedFile"
                    accept=".pdf"
                    color="primary"
                    counter
                    label="ไฟล์คำสั่งแต่งตั้งคณะกรรมการ"
                    placeholder="เลือกไฟล์ PDF"
                    prepend-icon="mdi-paperclip"
                    outlined
                    :show-size="1000"
                    class="modern-input"
                  />
                </v-col>

                <v-col cols="12">
                  <v-card class="status-card" outlined>
                    <v-card-text>
                      <v-radio-group
                        v-model="
                          settingsDialog.data.pertem_assistantFileIpastatus
                        "
                        class="status-radio-group"
                      >
                        <template v-slot:label>
                          <div class="status-label">
                            <v-icon color="primary" class="mr-2"
                              >mdi-information</v-icon
                            >
                            <strong>สถานะคำสั่งแต่งตั้ง</strong>
                          </div>
                        </template>
                        <v-radio value="process">
                          <template v-slot:label>
                            <div class="radio-label warning">
                              <v-icon color="orange" class="mr-2"
                                >mdi-clock</v-icon
                              >
                              <strong>อยู่ระหว่างดำเนินการ</strong>
                            </div>
                          </template>
                        </v-radio>
                        <v-radio value="notice">
                          <template v-slot:label>
                            <div class="radio-label success">
                              <v-icon color="green" class="mr-2"
                                >mdi-check-circle</v-icon
                              >
                              <strong>ประกาศแล้ว</strong>
                            </div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-alert type="info" outlined class="mt-4">
                <v-icon slot="prepend">mdi-information</v-icon>
                ข้อมูลที่จำเป็นต้องกรอก
              </v-alert>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn
              color="grey"
              outlined
              @click="closeSettingsDialog"
              rounded
              class="mr-2"
            >
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn
              color="success"
              @click="saveSettings"
              :loading="savingSettings"
              rounded
              elevation="2"
            >
              <v-icon left>mdi-content-save</v-icon>
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- PDF Dialog -->
      <v-dialog v-model="pdfDialog.show" max-width="90%" max-height="90%">
        <v-card elevation="8" rounded="lg">
          <v-card-title class="pdf-dialog-title">
            <v-icon color="red" class="mr-3">mdi-file-pdf-box</v-icon>
            <span>ไฟล์คำสั่งแต่งตั้งคณะกรรมการ</span>
            <v-spacer />
            <v-btn icon @click="pdfDialog.show = false" color="grey">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-divider></v-divider>

          <div class="pdf-container">
            <embed
              :src="'/HRCommitteeQf/' + pdfDialog.filename"
              width="100%"
              height="700px"
            />
          </div>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import Assistant_teacher_bar from "../../../components/admin/assistant_teacher_bar.vue";

export default {
  name: "TeacherManagementSystem",

  components: {
    Assistant_teacher_bar
  },

  data() {
    return {
      // การตั้งค่าทั่วไป
      apiKey: "HRvec2021",
      searchText: "",

      // สถานะการโหลด
      loadingTable: false,
      loadingCommittee: false,
      loadingScores: false,
      savingSettings: false,

      // ข้อมูลหลัก
      teacherData: [],
      statistics: {
        totalReported: 0,
        currentActive: 0,
        totalLeft: 0
      },

      // Chart instance
      chart: null,

      // ตั้งค่าตาราง
      tableHeaders: [
        {
          text: "ตรวจสอบบุคคล",
          align: "center",
          value: "personalCheck",
          sortable: false,
          width: "120px"
        },
        {
          text: "เสนอกรรมการ",
          align: "center",
          value: "committeeProposal",
          sortable: false,
          width: "120px"
        },
        {
          text: "การประเมิน",
          align: "center",
          value: "evaluation",
          sortable: false,
          width: "120px"
        },
        {
          text: "รายงาน",
          align: "center",
          value: "reports",
          sortable: false,
          width: "120px"
        },
        {
          text: "เอกสารแนบ",
          align: "center",
          value: "documents",
          sortable: false,
          width: "120px"
        },
        {
          text: "วันที่บรรจุ",
          align: "center",
          value: "dateApps",
          width: "140px"
        },
        {
          text: "วันที่ปฏิบัติงาน",
          align: "center",
          value: "mt_date_app_now",
          width: "140px"
        },
        {
          text: "ประเภท",
          align: "center",
          value: "personnelType",
          width: "120px"
        },
        {
          text: "ตั้งค่า",
          align: "center",
          value: "settings",
          sortable: false,
          width: "100px"
        },
        {
          text: "เลขที่คำสั่ง",
          align: "center",
          value: "mt_order_app",
          width: "140px"
        },
        {
          text: "ไฟล์คำสั่ง",
          align: "center",
          value: "orderFile",
          sortable: false,
          width: "120px"
        },
        {
          text: "จำนวนบรรจุ",
          align: "center",
          value: "mt_numfirst",
          width: "120px"
        },
        {
          text: "ครูผู้ช่วย",
          align: "center",
          value: "countAssistants",
          width: "120px"
        },
        { text: "หลัก", align: "center", value: "countManage", width: "100px" },
        {
          text: "ผ่าน 4 ครั้ง",
          align: "center",
          value: "countSuccess",
          width: "120px"
        },
        {
          text: "กำหนดครั้งที่ 1",
          align: "center",
          value: "month6",
          width: "140px"
        },
        {
          text: "กำหนดครั้งที่ 2",
          align: "center",
          value: "month12",
          width: "140px"
        },
        {
          text: "กำหนดครั้งที่ 3",
          align: "center",
          value: "month18",
          width: "140px"
        },
        {
          text: "กำหนดครั้งที่ 4",
          align: "center",
          value: "month24",
          width: "140px"
        }
      ],

      // ประเภทการบรรจุ
      personnelTypes: [
        { text: "รอบคัดเลือก", value: "select" },
        { text: "รอบแข่งขัน", value: "recruit" },
        { text: "รอบคืนถิ่น", value: "local_dev" },
        { text: "รอบโอน", value: "transfer_position" }
      ],

      // Dialog สำหรับตั้งค่า
      settingsDialog: {
        show: false,
        data: {}
      },

      // Dialog สำหรับไฟล์ PDF
      pdfDialog: {
        show: false,
        filename: ""
      },

      // ไฟล์ที่เลือก
      selectedFile: null,

      // กฎการตรวจสอบฟอร์ม
      requiredRules: [v => !!v || "กรุณากรอกข้อมูล"],

      filterDateApps: null, // วันที่บรรจุ
      menuDateApps: false, // สำหรับ v-menu
      filterDateWork: null, // วันที่ปฏิบัติงาน
      menuDateWork: false, // สำหรับ v-menu
      filterPersonnelType: null // ประเภท
    };
  },

  async mounted() {
    await this.loadTeacherData();
    this.initChart();
  },

  computed: {
    filteredTeacherData() {
      return this.teacherData.filter(item => {
        // ค้นหาทั่วไป
        const search = this.searchText
          ? (
              item.mt_order_app +
              " " +
              (item.mt_numfirst || "") +
              " " +
              (item.mt_type_personnel || "") +
              " " +
              (item.mt_date_app_now || "") +
              " " +
              (item.dateApps || "")
            )
              .toLowerCase()
              .includes(this.searchText.toLowerCase())
          : true;

        // กรองวันที่บรรจุ
        const dateApps = this.filterDateApps
          ? this.$moment(item.dateApps).format("YYYY-MM-DD") ===
            this.$moment(this.filterDateApps).format("YYYY-MM-DD")
          : true;

        // กรองวันที่ปฏิบัติงาน
        const dateWork = this.filterDateWork
          ? this.$moment(item.mt_date_app_now).format("YYYY-MM-DD") ===
            this.$moment(this.filterDateWork).format("YYYY-MM-DD")
          : true;

        // กรองประเภท
        const type = this.filterPersonnelType
          ? item.mt_type_personnel === this.filterPersonnelType
          : true;

        return search && dateApps && dateWork && type;
      });
    }
  },

  methods: {
    // Initialize ApexChart
    initChart() {
      if (typeof ApexCharts !== "undefined") {
        const options = {
          series: [this.statistics.currentActive, this.statistics.totalLeft],
          chart: {
            type: "donut",
            height: 300,
            fontFamily: "inherit"
          },
          labels: ["ปัจจุบัน", "ออกจากระบบ"],
          colors: ["#4CAF50", "#FF7043"],
          plotOptions: {
            pie: {
              donut: {
                size: "70%",
                labels: {
                  show: true,
                  total: {
                    show: true,
                    label: "รวมทั้งหมด",
                    formatter: () => this.statistics.totalReported
                  }
                }
              }
            }
          },
          legend: {
            position: "bottom",
            fontSize: "14px"
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: "bottom"
                }
              }
            }
          ]
        };

        this.chart = new ApexCharts(
          document.querySelector("#statistics-chart"),
          options
        );
        this.chart.render();
      }
    },

    // Update chart when data changes
    updateChart() {
      if (this.chart) {
        this.chart.updateSeries([
          this.statistics.currentActive,
          this.statistics.totalLeft
        ]);
      }
    },

    // โหลดข้อมูลครู
    async loadTeacherData() {
      try {
        this.loadingTable = true;
        const response = await this.$http.post(
          "manage_assistant_teacher_assessment.php",
          {
            ApiKey: this.apiKey,
            calendar_admin: "ok"
          }
        );

        this.teacherData = response.data;
        this.calculateStatistics();
        this.updateChart();
      } catch (error) {
        console.error("เกิดข้อผิดพลาดในการโหลดข้อมูล:", error);
        this.showErrorMessage("ไม่สามารถโหลดข้อมูลได้");
      } finally {
        this.loadingTable = false;
      }
    },

    // คำนวณสถิติ
    calculateStatistics() {
      let totalReported = 0;
      let currentActive = 0;

      this.teacherData.forEach(item => {
        totalReported += parseInt(item.countManage || 0);
        currentActive += parseInt(item.countAssistants || 0);
      });

      this.statistics = {
        totalReported,
        currentActive,
        totalLeft: totalReported - currentActive
      };
    },

    // อัปเดตรายชื่อกรรมการ
    async updateCommitteeList() {
      try {
        this.loadingCommittee = true;
        const response = await this.$http.post(
          "assistantcommitteequalified.updateToM.php"
        );

        if (response.data.status) {
          this.showSuccessMessage("อัปเดตรายชื่อกรรมการเรียบร้อย");
        } else {
          this.showErrorMessage("เกิดข้อผิดพลาดในการอัปเดต");
        }
      } catch (error) {
        this.showErrorMessage("ไม่สามารถอัปเดตได้");
      } finally {
        this.loadingCommittee = false;
      }
    },

    // ปรับปรุงคะแนนประเมิน
    async updateEvaluationScores() {
      try {
        this.loadingScores = true;
        await this.showLoadingMessage();

        const response = await this.$http.post(
          "manage_assistant_teacher.updateadmin.clear.php",
          {
            ApiKey: this.apiKey
          }
        );

        if (response.data.status) {
          this.showSuccessMessage("ปรับปรุงคะแนนประเมินเรียบร้อย");
        }
      } catch (error) {
        this.showErrorMessage("เกิดข้อผิดพลาดในการปรับปรุง");
      } finally {
        this.loadingScores = false;
        Swal.close();
      }
    },

    // เปิด Dialog ตั้งค่า
    async openSettingsDialog(item) {
      try {
        const response = await this.$http.post("manage_assistant_teacher.php", {
          ApiKey: this.apiKey,
          mt_appoin_day: item.mt_appoin_day,
          mt_appoin_month: item.mt_appoin_month,
          mt_appoin_year: item.mt_appoin_year,
          group_date: "ok"
        });

        this.settingsDialog.data = { ...response.data };
        this.settingsDialog.show = true;
      } catch (error) {
        this.showErrorMessage("ไม่สามารถโหลดข้อมูลได้");
      }
    },

    // ปิด Dialog ตั้งค่า
    closeSettingsDialog() {
      this.settingsDialog.show = false;
      this.settingsDialog.data = {};
      this.selectedFile = null;
      if (this.$refs.settingsForm) {
        this.$refs.settingsForm.resetValidation();
      }
    },

    // บันทึกการตั้งค่า
    async saveSettings() {
      if (!this.$refs.settingsForm.validate()) {
        return;
      }

      try {
        this.savingSettings = true;
        const dataToSave = { ...this.settingsDialog.data, ApiKey: this.apiKey };

        // อัปโหลดไฟล์หากมี
        if (this.selectedFile) {
          const filename = this.generateFilename();
          await this.uploadFile(filename);
          dataToSave.pertem_assistantFileIpa = filename;
        }

        const response = await this.$http.post(
          "manage_assistant_teacher.updateadmin.order.php",
          dataToSave
        );

        if (response.data.status) {
          this.showSuccessMessage("บันทึกข้อมูลเรียบร้อย");
          await this.loadTeacherData();
          this.closeSettingsDialog();
        } else {
          this.showErrorMessage("เกิดข้อผิดพลาดในการบันทึก");
        }
      } catch (error) {
        this.showErrorMessage("ไม่สามารถบันทึกข้อมูลได้");
      } finally {
        this.savingSettings = false;
      }
    },

    // อัปโหลดไฟล์
    async uploadFile(filename) {
      const formData = new FormData();
      formData.append("ApiKey", this.apiKey);
      formData.append("file", this.selectedFile);
      formData.append("filename", "../HRCommitteeQf/" + filename);

      return await this.$http.post("uploadfile.php", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
    },

    // สร้างชื่อไฟล์
    generateFilename() {
      const data = this.settingsDialog.data;
      const timeStamp = Math.floor(Date.now() / 1000);
      return `${data.mt_appoin_year}-${data.mt_appoin_month}-${data.mt_appoin_day}-${data.mt_type_personnel}.${timeStamp}.order.pdf`;
    },

    // ดูไฟล์คำสั่ง
    viewOrderFile(filename) {
      this.pdfDialog.filename = filename;
      this.pdfDialog.show = true;
    },

    // สร้าง Route URL
    getPersonalCheckRoute(item) {
      return `/admin/personnel_temporary_assisstant/?appoin_day=${item.mt_appoin_day}&appoin_month=${item.mt_appoin_month}&appoin_year=${item.mt_appoin_year}&mt_type=${item.mt_type_personnel}`;
    },

    getCommitteeRoute(item) {
      return `/admin/assistant_teacher_report/manage_assistant_teacher_committee/?appoin_day=${item.mt_appoin_day}&appoin_month=${item.mt_appoin_month}&appoin_year=${item.mt_appoin_year}&mt_admissions_status=receipt&mt_type=${item.mt_type_personnel}`;
    },

    getEvaluationRoute(item) {
      return `/admin/assistant_teacher/?appoin_day=${item.mt_appoin_day}&appoin_month=${item.mt_appoin_month}&appoin_year=${item.mt_appoin_year}&mt_type=${item.mt_type_personnel}`;
    },

    getReportsRoute(item) {
      return `/admin/assistant_teacher_reports/?appoin_day=${item.mt_appoin_day}&appoin_month=${item.mt_appoin_month}&appoin_year=${item.mt_appoin_year}&mt_type=${item.mt_type_personnel}`;
    },

    getTransferCommitteeRoute(item) {
      return `/admin/assistant_teacher_report/manage_assistant_teacher_committee/?appoin_day=${item.mt_appoin_day}&appoin_month=${item.mt_appoin_month}&appoin_year=${item.mt_appoin_year}&mt_type_personnel=transfer_position`;
    },

    getTransferEvaluationRoute(item) {
      return `/admin/assistant_teacher/?appoin_day=${item.mt_appoin_day}&appoin_month=${item.mt_appoin_month}&appoin_year=${item.mt_appoin_year}&mt_type_personnel=transfer_position`;
    },

    getTransferReportsRoute(item) {
      return `/admin/assistant_teacher_reports/?appoin_day=${item.mt_appoin_day}&appoin_month=${item.mt_appoin_month}&appoin_year=${item.mt_appoin_year}&mt_type_personnel=transfer_position`;
    },

    getDocumentsRoute(item) {
      return `/admin/assistant_teacher_report/manage_assistant_teacher_doc/?appoin_day=${item.mt_appoin_day}&appoin_month=${item.mt_appoin_month}&appoin_year=${item.mt_appoin_year}`;
    },

    // ฟังก์ชันช่วยเหลือ
    getPersonnelTypeColor(type) {
      const colors = {
        recruit: "blue",
        select: "green",
        transfer_position: "deep-purple",
        local_dev: "orange"
      };
      return colors[type] || "grey";
    },

    getPersonnelTypeText(type) {
      const texts = {
        recruit: "รอบแข่งขัน",
        select: "รอบคัดเลือก",
        transfer_position: "รอบโอน",
        local_dev: "รอบคืนถิ่น"
      };
      return texts[type] || "ไม่ระบุ";
    },

    formatDate(date) {
      if (!date) return "-";
      return this.$moment(date).format("D MMMM YYYY");
    },

    formatAppointmentDate(data) {
      if (!data.mt_date_app_now) return "-";
      return this.$moment(data.mt_date_app_now)
        .add(543, "year")
        .format("D MMMM YYYY");
    },

    // ข้อความแจ้งเตือน
    async showLoadingMessage() {
      Swal.fire({
        title: "กรุณารอสักครู่...",
        timerProgressBar: true,
        didOpen: () => Swal.showLoading(),
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    },

    showSuccessMessage(message) {
      Swal.fire({
        icon: "success",
        title: message,
        showConfirmButton: false,
        timer: 2000
      });
    },

    showErrorMessage(message) {
      Swal.fire({
        icon: "error",
        title: message,
        showConfirmButton: false,
        timer: 2000
      });
    }
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
};
</script>

<style scoped>
/* Global Styles */
.teacher-management-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

/* Header Section */
.header-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  padding: 30px;
  color: white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.page-title-container {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 2.2rem;
  font-weight: 600;
  margin: 0;
}

.page-subtitle {
  font-size: 1.1rem;
  opacity: 0.9;
  margin: 0;
}

/* Statistics Cards */
.stats-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.stats-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
}

.stats-card-title {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px 24px;
  font-size: 1.3rem;
  font-weight: 600;
}

.stats-mini-card {
  transition: all 0.3s ease;
  border-radius: 15px;
  margin-bottom: 15px;
}

.stats-mini-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.total-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.active-card {
  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%);
}

.left-card {
  background: linear-gradient(135deg, #ff7043 0%, #ff5722 100%);
}

/* Data Table */
.data-table-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.data-table-title {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 24px;
  font-size: 1.4rem;
  font-weight: 600;
}

.search-field {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
}

.search-field >>> .v-input__control .v-input__slot {
  background: rgba(255, 255, 255, 0.2) !important;
}

.search-field >>> .v-input__control .v-input__slot input {
  color: white !important;
}

.search-field >>> .v-input__control .v-input__slot label {
  color: rgba(255, 255, 255, 0.8) !important;
}

/* Modern Table Styles */
.modern-table {
  background: white;
}

.modern-table >>> .v-data-table__wrapper {
  border-radius: 0;
}

.modern-table >>> .v-data-table-header {
  background: #f8f9fa;
}

.modern-table >>> .v-data-table-header th {
  background: #f8f9fa !important;
  color: #2c3e50 !important;
  font-weight: 600;
  padding: 16px 8px;
  border-bottom: 2px solid #e9ecef;
}

.modern-table >>> .v-data-table tbody tr {
  transition: all 0.2s ease;
}

.modern-table >>> .v-data-table tbody tr:hover {
  background-color: #f8f9fa !important;
  transform: scale(1.001);
}

.modern-table >>> .v-data-table tbody td {
  padding: 12px 8px;
  border-bottom: 1px solid #e9ecef;
}

/* Action Buttons */
.action-btn {
  margin: 2px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.25);
}

/* Personnel Chip */
.personnel-chip {
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Date Cell */
.date-cell {
  font-weight: 500;
  color: #2c3e50;
  white-space: nowrap;
}

/* Settings Dialog */
.settings-dialog-card {
  background: white;
  overflow: hidden;
}

.settings-dialog-title {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 24px;
  font-size: 1.4rem;
  font-weight: 600;
}

.appointment-date-display {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  padding: 20px;
  border-radius: 15px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: 600;
  color: #1565c0;
  border: 2px solid #2196f3;
}

.modern-input >>> .v-input__control .v-input__slot {
  border-radius: 12px;
  background: #f8f9fa;
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
}

.modern-input >>> .v-input__control .v-input__slot:hover {
  border-color: #667eea;
  background: white;
}

.modern-input.v-input--is-focused >>> .v-input__control .v-input__slot {
  border-color: #667eea;
  background: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.2);
}

/* Status Card */
.status-card {
  background: #f8f9fa;
  border-radius: 15px;
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
}

.status-card:hover {
  border-color: #667eea;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.1);
}

.status-label {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: 1.1rem;
  color: #2c3e50;
}

.status-radio-group >>> .v-input--radio-group__input {
  flex-direction: column;
  gap: 15px;
}

.radio-label {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.radio-label.warning {
  background: #fff3e0;
  color: #ef6c00;
}

.radio-label.success {
  background: #e8f5e8;
  color: #2e7d32;
}

/* PDF Dialog */
.pdf-dialog-title {
  background: linear-gradient(135deg, #d32f2f 0%, #c62828 100%);
  color: white;
  padding: 20px 24px;
  font-size: 1.3rem;
  font-weight: 600;
}

.pdf-container {
  background: #f5f5f5;
  padding: 20px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .page-title {
    font-size: 1.8rem;
  }

  .page-subtitle {
    font-size: 1rem;
  }

  .header-section {
    padding: 20px;
  }

  .action-btn {
    width: 32px;
    height: 32px;
  }

  .modern-table >>> .v-data-table tbody td {
    padding: 8px 4px;
  }
}

/* Loading Animation */
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.v-progress-circular {
  animation: pulse 2s infinite;
}

/* Scrollbar Styling */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
}
</style>
